import { FC } from 'react';

import { Table } from '@dbt-labs/sourdough';

import { SemanticModelEntity } from '@/__generated__/graphql';
import { DetailsSection } from '@/components/SectionWithCard';
import {
  GenericResourceNode,
  getDefinitionSemanticModel,
} from '@/hooks/discovery/types';

interface SemanticModelEntitiesProps {
  resource: GenericResourceNode;
}

export const SemanticModelEntities: FC<SemanticModelEntitiesProps> = ({ resource }) => {
  const semanticModel = getDefinitionSemanticModel(resource);
  if (!semanticModel) return null;
  const entities = semanticModel.entities;
  if (!entities || !entities?.length) return null;

  return (
    <DetailsSection heading="Entities" withCard={false}>
      <Table
        columns={[
          { header: 'Name', accessorKey: 'name', size: 80, minSize: 150 },
          { header: 'Type', accessorKey: 'type', size: 60, minSize: 120 },
          { header: 'Description', accessorKey: 'description' },
        ]}
        data={entities as SemanticModelEntity[]}
        isSortable={false}
        rowHeight={52}
      />
    </DetailsSection>
  );
};
